/**
 * Component of the gateApp, takes care of www#/support route.
 */
angular.module('gateApp').component('support', {
  template: require('./support.html').default,
  controller: function (
    $window: ng.IWindowService,
    $sce: ng.ISCEService,
    language: any,
  ) {
    const $ctrl = this;

    $ctrl.currentLanguage$ = language.current$;

    $ctrl.content = {};

    const host = $window.location.host;
    if (host.includes('qliqpoint')) {
      $ctrl.content['en-gb'] = $sce.trustAsHtml(
        require('./en-gb-qliqpoint.html').default,
      );
      $ctrl.content['nl-nl'] = $sce.trustAsHtml(
        require('./nl-nl-qliqpoint.html').default,
      );
      $ctrl.content['de-de'] = $sce.trustAsHtml(
        require('./de-de-qliqpoint.html').default,
      );
      $ctrl.content['es-es'] = $sce.trustAsHtml(
        require('./es-es-qliqpoint.html').default,
      );
      $ctrl.content['fr-fr'] = $sce.trustAsHtml(
        require('./fr-fr-qliqpoint.html').default,
      );
      $ctrl.content['it-it'] = $sce.trustAsHtml(
        require('./it-it-qliqpoint.html').default,
      );
    } else {
      $ctrl.content['en-gb'] = $sce.trustAsHtml(
        require('./en-gb.html').default,
      );
      $ctrl.content['nl-nl'] = $sce.trustAsHtml(
        require('./nl-nl.html').default,
      );
    }
  },
});
